//@ts-strict-ignore
import React, { useContext } from 'react';
import { EditorState, Modifier } from 'draft-js';
import { Button } from './connectedForm/Button';
import MergeFieldContext from './Context/MergeFieldContext';
import isFunction from './react-data-grid/utils/isFunction';
import { IContextualMenuItem } from '@fluentui/react';

export const addOnClickOptionToMergeFields: (
  mergeFields: Array<IContextualMenuItem>,
  onClick: Function
) => Array<IContextualMenuItem> = (mergeFields, onClick) => {
  return mergeFields?.map((field) => {
    if (!!field.subMenuProps) {
      return {
        ...field,
        subMenuProps: {
          ...field.subMenuProps,
          items: addOnClickOptionToMergeFields(field.subMenuProps.items, onClick),
        },
      };
    }
    return {
      ...field,
      onClick: (event, option) => {
        onClick(option?.key);
      },
    };
  });
};

export const MergeFieldToolbarOption = (props: { editorState?: any; onChange?: Function }) => {
  const { mergeFields } = useContext(MergeFieldContext);

  if (!mergeFields || mergeFields?.length === 0) {
    return null;
  }

  const { editorState, onChange } = props;

  const addMergeField = (mergeField) => {
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      `{{${mergeField}}}`,
      editorState.getCurrentInlineStyle()
    );

    const newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
    onChange?.(EditorState.forceSelection(newEditorState, contentState.getSelectionAfter()));
  };

  const options = addOnClickOptionToMergeFields(isFunction(mergeFields) ? mergeFields() : mergeFields, addMergeField);

  return (
    <Button
      text={'Merge Field'}
      menuProps={{
        items: options,
      }}
    />
  );
};
